module.exports = __webpack_public_path__ + "static/feature-project-dashboard-7bd9521be3f8f6eb386c94d845cd0efd.png";